import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
// import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faSquareGithub } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div className="w-full bg-custombg lg:h-[18vh] sm: h-[8vh] text-white flex items-center justify-center p-2">
      <div className="w-11/12 flex justify-between items-center">
        <p className="lg:text-lg sm: text-xs">
          © 2024 Pushkar. All rights reserved.
        </p>
        <div className="flex lg:gap-4 sm: gap-2">
          <a
            href="https://github.com/Pushkar155"
            target="_blank"
            without
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faSquareGithub} className="lg:h-8 sm: h-4" />
          </a>
          <a
            href="https://www.linkedin.com/in/pushkar-chaubey-145311202/"
            target="_blank"
            without
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} className="lg:h-8 sm: h-4" />
          </a>
          <a
            href="https://www.instagram.com/pushkarchaubey10/?hl=en"
            target="_blank"
            without
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} className="lg:h-8 sm: h-4" />
          </a>

          {/* <a href="https://github.com/Pushkar155" target='_blank' without rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} className='lg:h-8 sm: h-4' /></a>   */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
